import { IStoreLocatorSearch } from '@models/IStoreLocatorSearch';
import { IStoreLocatorSearchParams } from '@models/IStoreLocatorSearchParams';
import axios from 'axios';
import qs from 'qs';

const storeLocatorSearch = async ({
  endpoint,
  input,
  latitude,
  longitude,
  distance,
  countryCode,
  languageCode,
  placeId,
}: IStoreLocatorSearchParams): Promise<IStoreLocatorSearch> => {
  const query = qs.stringify({
    Input: input || '',
    PlaceId: placeId || '',
    Latitude: latitude || '0',
    Longitude: longitude || '0',
    MarketId: countryCode?.toUpperCase() || '',
    SiteLanguageCode: languageCode,
    Distance: distance || 50,
    SearchByDistance: true,
    IsDealerRequest: true,
    IsPurchaseIntentRequest: false,
    Type: 'physical',
  });

  const { data } = await axios.get<IStoreLocatorSearch>(`${endpoint}?${query}`);

  return data;
};

export default storeLocatorSearch;
